import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { IDocument } from '../generic';

export interface INotification extends IDocument {
  body: string,
  eventId: string,
  message: string,
  title: string,
  toUserId: string,
  type: string
}

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(private afs: AngularFirestore) {

  }

  getNotifications(userId?: string) {
    return this.afs.collection<INotification>('/notification').valueChanges({ idField: 'id' })
  }

  addNotification(eventId: string, toUserId: string, title: string, message: string) {
    return this.afs.collection<INotification>('/notification').add({
      body: message,
      eventId: eventId,
      message: message,
      title: title,
      toUserId: toUserId,
      type: "event"
    })
  }
}
